

export const LoginAppStates = () => {
  let loginAppStates =
    localStorage.getItem("login-app-states");
  if (loginAppStates) {
    loginAppStates = JSON.parse(loginAppStates);
    return loginAppStates;
  }
  return {};
};
